/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";


const Tarjeta_Testimonio = ({item, escogida}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderBottom: escogida === item.id ? 8 : 0,
                borderColor: theme.palette.primary.main,
                borderRadius: 0
            }}
        >

            <Grid container size={{xs: 5, sm: 5, md: 5}} sx={{justifyContent: 'flex-start'}}>

                <video width={'100%'} height={'auto'}
                       style={{
                           objectFit: 'cover', borderRadius: 20,
                           zIndex: 1
                       }}
                       id="background-video" controls loop muted //poster={fondo_img}
                >
                    <source src={item.video} type="video/mp4"/>
                </video>

            </Grid>

            <Grid container size={{xs: 7, sm: 7, md: 7}} sx={{justifyContent: 'flex-start', pl: 3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{color: theme.palette.primary.main, fontSize: 16, fontWeight: 500, lineHeight: 1.1}}>
                            {item.titulo}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{color: '#262626', fontSize: 24, fontWeight: 700, lineHeight: 1.1}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#545454', fontSize: 14, fontWeight: 400, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 4
                        }}>
                            {item.parrafoUno}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#545454', fontSize: 14, fontWeight: 400, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 8
                        }}>
                            {item.parrafoDos}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Testimonio